<template>
  <v-form class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>
    <h3 class="text-left mb-1 text-primary">Initialize Profile</h3>
    <p class="text-caption mb-4">Inicializá un perfil dentro de un keystore.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
             size="small"
             color="primary"
             @click="initializeProfile"
             :disabled="!valid">
        Initialize profile >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-select
                  v-model="selectedKeyStoreId"
                  item-title="id"
                  item-value="id"
                  label="keyStoreId"
                  @update:modelValue="keyStoreChanged"
                  :items="keyStoreIdsList"
        ></v-select>
        <v-autocomplete
                        v-model="selectedProfile"
                        :items="profileList"
                        item-title="friendlyName"
                        item-value="name"
                        label="Profile"
        ></v-autocomplete>
      </v-col>
      <v-col md="6">
        <v-textarea
                    name="parameters"
                    label="Parameters"
                    no-resize
                    height="150px"
                    v-model="requestPayload"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <v-textarea
                    name="response"
                    label="Response"
                    auto-grow
                    v-model="response"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default {
    props:['keyStoreIds', 'keyStoreInfo', 'keyStoreId', 'data'],
    data: () => ({
      requestPayload: '{}',
      selectedKeyStoreId: "",
      selectedProfile: "",
      keyStoreIdsList: [],
      profileList: [],
      response: "",
      valid: false
    }),
    watch:{
      keyStoreId(){
        this.selectedKeystoreId = this.keyStoreId;
      },
      keyStoreInfo(){
        this.profileList.push({friendlyName: 'none', name:''})
        this.keyStoreInfo.forEach(elem => this.profileList.push(elem))
      },
      selectedProfile(value){
        this.updatePayload('keyStore','profile', value)
      }
    },
    mounted() {
      this.loadKeyStores()
      this.selectedKeyStoreId = this.keyStoreIdsList.find((key)=>key.id === this.keyStoreId) ? this.keyStoreId : null;
      if (this.selectedKeyStoreId) {
        const _keystore = this.keyStoreIdsList.filter((key)=>key.id === this.selectedKeyStoreId)[0];
        this.updatePayload('keyStore','id', this.selectedKeyStoreId)
        if (keystore.keyStoreType !== "TOKEN")
          this.profileList.push({friendlyName: 'new profile', name:''})
      }
      this.keyStoreInfo.forEach(elem => this.profileList.push(elem))
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      keyStoreChanged(){
        this.updatePayload('keyStore','id',this.selectedKeyStoreId)
        this.selectedProfile = null
        this.getKeyStoreInfo(this.selectedKeyStoreId)
      },

      initializeProfile(){
        alisonJS.initializeProfile(JSON.parse(this.requestPayload)).then((result)=>{
          this.response = JSON.stringify(result, null , "\t")
        }, (e) => {
          this.setColor('error')
          if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
          }else{
            this.setSnack('FAILURE: ' + JSON.stringify(e))
          }
          this.response = JSON.stringify(e, null, "\t");
        })
      },
      getKeyStoreInfo(keyStoreId) {
        this.profileList = []
        alisonJS.keyStoreInfo({id:keyStoreId}).then((info) => {
          this.setColor('info'); this.setSnack('KeyStore info obtained successfully');

          const _keystore = this.keyStoreIdsList.filter((key)=>key.id === keyStoreId)[0];
          if(_keystore && _keystore.keyStoreType !== "TOKEN") this.profileList.push({friendlyName: 'new profile', name:''})
          info.keyStores.forEach(ks => {
            this.profileList = this.profileList.concat(ks.profiles)
          });
        }).catch(e=>{
            this.setColor('error'); this.setSnack('FAILURE: ' + JSON.stringify(e))
        })
      },
      loadKeyStores() {
        alisonJS.listKeyStores().then((list) => {
              this.keyStoreIdsList = list.keyStores.filter((key)=>key.capabilities.includes('G'));
              this.setColor('success'); this.setSnack('KeyStores obtained successfully')
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
          })
      },
      updatePayload(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if (key2) {
          if (!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      }
    }
  }
</script>
